<div class="grid grid-cols-12 gap-x-3">
    <div
        bigUiHeadingStyle
        [innerHTML]="html"
        class="col-span-12"
        [ngClass]="{
            'lg:col-span-10 lg:col-start-2': !data.fullWidth
        }"></div>
</div>
